regexParam = /\{(\d+)\}/g

formatStringFilter = ->
  (input) ->
    arg = arguments
    input = input.replace(regexParam , (match, capture) ->
      arg[Number(capture) + 1]
    )

module.exports = formatStringFilter



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/format-string-filter.coffee